import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InfoCircleFullBlue = () => (_jsxs("svg", Object.assign({ id: "Icons", xmlns: "http://www.w3.org/2000/svg", x: 0, y: 0, viewBox: "0 0 16 16", xmlSpace: "preserve" }, { children: [_jsx("style", { children: '.st1{fill:#fff}' }), _jsx("circle", { cx: 8, cy: 8, r: 8, style: {
                fill: '#376eb4',
            } }), _jsx("path", { className: "st1", d: "M7 7h2v5H7zM7 4h2v2H7z" })] })));
export default InfoCircleFullBlue;
